import { render, staticRenderFns } from "./Cooperation.vue?vue&type=template&id=2dada078"
import script from "./Cooperation.vue?vue&type=script&lang=js"
export * from "./Cooperation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-pharmacy\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2dada078')) {
      api.createRecord('2dada078', component.options)
    } else {
      api.reload('2dada078', component.options)
    }
    module.hot.accept("./Cooperation.vue?vue&type=template&id=2dada078", function () {
      api.rerender('2dada078', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/manager/pharmacy/Cooperation/Cooperation.vue"
export default component.exports